import type { ContestSettings, SlateLabelEnum } from '@betterpool/api-types/contests-service';

import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';
import dt from '~/testing';

import { Section, SectionContent, SectionTitle } from '../components';

import ScheduleSection from './ScheduleSection';
import useGetScheduleTitle from './useGetScheduleTitle';

type ScheduleProps = {
  slates: ContestSlate[];
  isSidePanel?: boolean;
  segments?: ContestSettings['segments'];
  slateLabel?: SlateLabelEnum;
  isEntryDeadlinePending?: boolean;
  groupStageSlateId?: string;
};

function Schedule({
  slateLabel,
  slates,
  isSidePanel,
  segments,
  isEntryDeadlinePending,
  groupStageSlateId,
}: ScheduleProps) {
  const segmentTitle = useGetScheduleTitle({
    slates,
    slateLabel,
    segmentType: segments?.segmentType,
  });

  if (!segments) return null;

  return (
    <Section>
      <SectionTitle data-test-id={dt.contestDetail.section.prizes.title} isSidePanel={isSidePanel}>
        {segmentTitle}
      </SectionTitle>
      <SectionContent isSidePanel={isSidePanel}>
        <ScheduleSection
          slates={slates}
          segments={segments}
          isSidePanel={isSidePanel}
          slateLabel={slateLabel}
          isEntryDeadlinePending={isEntryDeadlinePending}
          groupStageSlateId={groupStageSlateId}
        />
      </SectionContent>
    </Section>
  );
}

export default Schedule;
